/* tslint:disable */
 
import { ActionInfo } from './action-info';
import { AuthenticatedCollectionOption } from './authenticated-collection-option';
import { Configuration } from './configuration';
import { DataCollectionRelatedTo } from './data-collection-related-to';
import { Icon } from './icon';
import { LocalizedValue } from './localized-value';
import { NullableLocalizedValue } from './nullable-localized-value';
import { Permission } from './permission';

/**
 * (tsType: Omit<DataCollections, >, schemaOptions: { includeRelations: undefined, exclude: [] })
 */
export class DataCollections {
  authenticated?: AuthenticatedCollectionOption;
  collectionType: 0 | 1 | 2 | 3;
  configuration?: Configuration;
  creationInfo?: ActionInfo;
  dataEntity: string;
  description?: null | NullableLocalizedValue;
  duplicatedFrom?: string;
  icon?: null | Icon;
  id?: string;
  isImplicit: boolean;
  items?: Array<any>;
  module: string;
  name: LocalizedValue;
  relatedTo?: DataCollectionRelatedTo;
  sharedTo?: Array<Permission>;
  specificationVersion: number;
  updateInfo?: ActionInfo;
  visibility: 0 | 1 | 2;
}
